import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Jugurtha AIT OUFELLA </span>
            from <span className="purple"> Lille, France.</span>
            <br /> I am a Software Engineer.
            <br />
           I am currently on a freelance mission as a software developer for Adeo
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Muay Thai
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(84, 160, 255)" }}>
            "Strive to build things that make the users satisfied !"{" "}
          </p>
          <footer className="blockquote-footer">Jugurtha</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
